import React, { useEffect } from 'react';
import { VariableSizeList } from 'react-window';
import { Box, IntrinsicImage, useBreakpointIndex } from '@tishman/components';

import { PrivateEventsImageCaption } from '../PrivateEventsImageCaption';

import { PrivateEventsGalleryArrows } from './PrivateEventsGalleryArrows';
import { useCarousel, TPrivateEventsGalleryCarouselItem } from './useCarousel';

type TPrivateEventsGalleryCarousel = {
  items: TPrivateEventsGalleryCarouselItem[];
};

export const PrivateEventsGalleryCarousel = ({
  items = [],
}: TPrivateEventsGalleryCarousel) => {
  const isMobile = useBreakpointIndex() < 2;
  const {
    beginning,
    end,
    getImageWidth,
    handlePrevious,
    handleNext,
    listRef,
    onListScroll,
    width,
  } = useCarousel(items);

  return (
    <Box
      sx={{
        marginTop: [-4, '-40px'],
        overflow: 'hidden',
        position: 'relative',
      }}
    >
      <PrivateEventsGalleryArrows
        beginning={beginning}
        end={end}
        handleNext={handleNext}
        handlePrevious={handlePrevious}
      />
      <Box
        sx={{
          paddingLeft: 0,
          overflow: 'hidden',
        }}
      >
        {items && (
          <VariableSizeList
            height={isMobile ? 220 : 430}
            itemCount={items.length}
            itemSize={(index) => getImageWidth(index)}
            key={`variable-size-list-${isMobile}`}
            layout="horizontal"
            onScroll={onListScroll}
            ref={listRef as React.LegacyRef<any>} // eslint-disable-line @typescript-eslint/no-explicit-any -- this won't work without the any type here
            style={{
              scrollbarWidth: 'none',
              margin: `${isMobile ? 4 : 0} auto 0`,
              overflowY: 'hidden',
              maxWidth: isMobile ? width : 'auto',
            }}
            width={isMobile ? width : 1440}
          >
            {({ index, style }) => {
              const item = items[index];

              return (
                <Box key={index} style={{ position: 'relative', ...style }}>
                  <IntrinsicImage
                    image={item.asset.gatsbyImageData}
                    sx={{
                      maxWidth: '645px',
                      width: 'auto',
                      height: ['220px', '220px', '430px'],
                      marginRight: '16px',
                      objectFit: 'cover',
                      marginLeft: [0, index === 0 ? '70px' : 0],
                    }}
                  />
                  {item.caption && (
                    <PrivateEventsImageCaption
                      right="30px"
                      text={item.caption}
                    />
                  )}
                </Box>
              );
            }}
          </VariableSizeList>
        )}
      </Box>
    </Box>
  );
};
